module.exports = __webpack_public_path__ + "static/partner.chart-e6cb8e5138d8379f1446d8c6bfbcc13a.png";